'use strict';

var o;function i(n){o=n;}function l(n){sessionStorage.clear(),localStorage.clear(),n.logoutRedirect();}function r(n){n.loginRedirect();}var s=async(n,t)=>{try{let e={scopes:t,account:n};return (await o.acquireTokenSilent(e)).idToken}catch(e){return console.error("Error acquiring token silently:",e),e}};

exports.a = i;
exports.b = l;
exports.c = r;
exports.d = s;
